import { render, staticRenderFns } from "./login-support.vue?vue&type=template&id=08d03fe2&scoped=true&"
import script from "./login-support.vue?vue&type=script&lang=ts&"
export * from "./login-support.vue?vue&type=script&lang=ts&"
import style0 from "./login-support.vue?vue&type=style&index=0&id=08d03fe2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d03fe2",
  null
  
)

export default component.exports